export default __webpack_public_path__ + "static/media/hero-bg-4.416273e6.jpg";